import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Class name merge utility — combines + deduplicates Tailwind classes.
 * Uses clsx for conditional logic and tailwind-merge to resolve conflicts.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
